import React from 'react';
import { useLocation } from 'react-router-dom';
import { ButtonLink } from '../../core';
import { BacktestType } from '@sc1/common';

export const BacktestTab = ({
  position,
  currentPosition,
  label,
}: {
  position: BacktestType;
  currentPosition: BacktestType;
  label: string;
}): JSX.Element => {
  const { search } = useLocation();
  return (
    <ButtonLink
      mr={3}
      variant={position == currentPosition ? 'buttons.tab' : 'buttons.tabFaded'}
      sx={{ textTransform: 'capitalize' }}
      to={() => ({
        pathname: `/backtest/${position}`,
        search,
      })}
    >
      {label}
    </ButtonLink>
  );
};
